import React from 'react';
import { useTranslation } from 'react-i18next';

import { ModalDialog } from '../common/ModalDialog';

import styles from './LanguageDialogConfirmation.module.css';

const LanguageDialogConfirmation = ({
  show = false,
  onClose = () => { },
  onConfirm = () => { },
}) => {
  const { t } = useTranslation('common');

  return (
    <ModalDialog
      onClose={onClose}
      show={show}
    >
      <div className={styles.mainContainer}>
        <h1>{t('languageDialog.title')}</h1>

        <p>{t('languageDialog.description')}</p>

        <div className={styles.buttonsContainer}>
          <button onClick={onClose} type="button">
            {t('languageDialog.cancelButton')}
          </button>

          <button data-red onClick={onConfirm} type="button">
            {t('languageDialog.continueButton')}
          </button>
        </div>
      </div>
    </ModalDialog>
  );
};

export { LanguageDialogConfirmation };
